import MasonryGrid from '../components/MasonryGrid';
import FacetedFilters from '../components/FacetedFilters';
import ProductListItem from '../components/ProductListItem';

export default class StaticSearch {
  constructor(section) {
    this.el = section.el;
    this.facetedFilters = new FacetedFilters(section);
    this.masonry = this.el.querySelector('[data-masonry-grid]');
    this.masonryGrid = null;

    this.productListItems = [];
    this.el
      .querySelectorAll('.product-list-item')
      .forEach(product => this.productListItems.push(new ProductListItem({ el: product })));

    if (this.masonry) {
      this.masonryGrid = new MasonryGrid({
        el: this.masonry,
        settings: {
          itemSelector: '.product-list-item',
          horizontalOrder: true,
        },
      });
    }
  }

  remove() {
    if (this.masonryGrid) {
      this.masonryGrid.unload();
    }

    this.productListItems.forEach(item => item.remove());
  }

  onSectionUnload() {
    this.remove();
    this.facetedFilters.unload();
  }
}
